// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"685c6189","135":"6ca69948","164":"5c007143","169":"17de8783","361":"14e50213","484":"cfa1e59a","503":"af53b409","945":"3ce1f191","980":"fa322d7b"}[chunkId] + ".chunk.js";
};